#ifdef GL_ES
precision mediump float;
#endif

attribute vec3 color;
attribute float sizes;
attribute float opacity;
attribute float randomValue;

varying vec3 vColor;
varying float vAlpha;
varying float vOpacity;
varying float vRandom;


uniform float uMinRadius;  
uniform float uMaxRadius;  

uniform float uMinSize;   
uniform float uMinOpacity;

void main() {
    float dLocal = length(position);
    float wDist = clamp((dLocal - uMinRadius) / (uMaxRadius - uMinRadius), 0.0, 1.0);
    vColor = color;
    vAlpha = 1.0;
    vOpacity = max(opacity * (1.-wDist), uMinOpacity);
    vRandom  = randomValue;

    vec4 mvPos = modelViewMatrix * vec4(position, 1.0);
    float viewZ = -mvPos.z;
    if (viewZ <= 0.0) {
        gl_PointSize = 0.0;
    } else {
        float baseSize = max(sizes * wDist*0.5, uMinSize);
        float projectedSize = baseSize * (300.0 / viewZ);
        gl_PointSize = projectedSize;
    }
    gl_Position = projectionMatrix * mvPos;
}
